import { LADDER as LABELS } from './labels.js';

export default {
  data: [],
  option: {
    header: false,
    menuAlign: 'left',
    editBtn: false,
    indexLabel: '#',
    border: true,
    searchShow: false,
    columnBtn: false,
    searchBtn: true,
    refreshBtn: false,
    highlightCurrentRow: true,
    index: true,
    fit: true,
    searchSpan: 12,
    searchMenuSpan: 12,
    emptyText: LABELS.noData,
    column: [
      {
        span: 24,
        label: LABELS.numberOfSteps,
        prop: 'ladderQuantity',
        rules: [
          {
            required: true,
            message: `${LABELS.pleaseEnter} ${LABELS.numberOfSteps}`,
            trigger: 'blur'
          }
        ]
      },
      {
        addDisplay: false,
        label: LABELS.ladderStep,
        prop: 'ladderGrade'
      }
    ]
  }
};
